// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2ZR_g","content":"LoadingAlert_content__1M1w3"};